<template>
  <div>
    <imgHeader imgUrl="/img/地图.gif" />
    <div class="w main">
      <h3 class="title" style="text-align: center">
        {{ $t('contactUs.title') }}
      </h3>
      <div class="line line1"></div>
      <div class="container">
        <div
            class="nation flex"
            v-for="(item, index) in list"
            :key="index"
            :id="item.id"
        >
          <div class="address flex">
            <h4>{{ item.country }}</h4>
            <div class="map" :id="item.id">
              <baidu-map
                  class="bmView"
                  :scroll-wheel-zoom="true"
                  :center="item.location"
                  :zoom="item.zoom"
                  :label="111"
                  ak="nblAgDR8asULI1Rga98YiQVTSlRDXb4h"
              >
                <bm-marker
                    :position="{ lng: item.location.lng, lat: item.location.lat }"
                    :dragging="true"
                >
                  <bm-label :labelStyle="{ display: 'none' }" />
                </bm-marker>
                <bm-view style="width: 100%; height:100%; flex: 1"></bm-view>
              </baidu-map>
            </div>
          </div>
          <div class="hLine"></div>
          <div class="contact flex">
            <h3>{{ $t('contactUs.contactTitle') }}</h3>
            <div class="flex">
              <img src="/img/1首页-bottom-icon2.png" alt="phone" />
              <span>{{ item.tel }}</span>
            </div>
            <div class="flex">
              <img src="/img/1首页-bottom-icon1.png" alt="email" />
              <span>{{ item.email }}</span>
            </div>
            <div class="flex">
              <img src="/img/1首页-bottom-icon3.png" alt="address" />
              <span>{{ item.address }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { t } from '@/VueI18n'

export default {
  name: 'ContactUs',
  data() {
    return {
      list: [
        {
          id: 'china',
          location: {
            lng: 120.004802,
            lat: 29.285518,
          },
          zoom: 16,
          email: 'liming@kmt-style.net',
          address: t('contactUs.chinaAddress'),
          tel: '0579-85541088',
          country: t('contactUs.china'),
        },
      ],
    }
  },
  watch: {
    '$i18n.locale'() {
      this.updateList()
    }
  },
  mounted() {
    this.updateList()
  },
  methods: {
    updateList() {
      this.list = [
        {
          id: 'china',
          location: {
            lng: 120.004802,
            lat: 29.285518,
          },
          zoom: 16,
          email: 'liming@kmt-style.net',
          address: t('contactUs.chinaAddress'),
          tel: '0579-85541088',
          country: t('contactUs.china'),
        },
      ]
    }
  },
}
</script>

<style lang="scss" scoped>
.flex {
  img {
    width: 20px;
    height: 22px;
  }
}
.container {
  margin-top: 60px;
}
.nation {
  width: 1100px;
  height: 400px;
  margin: 0 auto;
  margin-bottom: 30px;
  border: 1px solid #eaeaea;
}
.address {
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  background-color: var(--bg-color);
}
.hLine {
  width: 1px;
  height: 250px;
  background-color: #eaeaea;
}
.contact {
  flex-direction: column;
  justify-content: center;
  padding-left: 50px;
  width: 400px;
  color: #333;
  & > div {
    align-content: center;
    margin-bottom: 10px;
    img {
      margin-right: 20px;
    }
  }
}
.map {
  width: 500px;
  height: 300px;
  margin-left: 40px;
}
.bmView {
  height: 100%;
}
</style>